<div class="w-100 mt-0 tool-container">
  <h4>Data Dictionary</h4>
  <mat-form-field class="me-0">
    <mat-label>Implementation</mat-label>
    <mat-select [(ngModel)]="dataDictionary.solution">
      @for (app of applications; track app.value) {
        <mat-option [value]="app.value">
          {{ app.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="col-4">
    <input
      type="text"
      placeholder="Search For a Unit"
      matInput
      [(ngModel)]="dataDictionary.firm"
      [matAutocomplete]="auto"
      name="unitsControl"
      [formControl]="unitsControl"
      (blur)="checkSelection()"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="autoCompleteUnitChanged($event)"
    >
      @for (unit of filteredUnits; track unit.id) {
        <mat-option [value]="unit.id">
          {{ unit.name }} - ({{ unit.id }})
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>Group</mat-label>
    <input matInput [(ngModel)]="dataDictionary.group" />
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>UI Config</mat-label>
    <input matInput [(ngModel)]="dataDictionary.uiConfig" />
  </mat-form-field>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="getDataDictionary()"
    [disabled]="
      !(dataDictionary.solution && dataDictionary.group && dataDictionary.firm)
    "
  >
    Request
  </button>
</div>
